/* eslint-disable no-use-before-define */
/* eslint-disable import/order */
/*
 * @Author: gvillena
 * @Date: 2020-06-26 02:32:28
 * @Last Modified by: gvillena
 * @Last Modified time: 2020-06-26 02:51:04
 */
/* eslint-disable spaced-comment */

import {
  Button,
  Col,
  Icons,
  Layout as LayoutBase,
  Modal,
  Row,
  Spin,
  Table,
  notification,
} from 'fractalia-design';

import React, { useEffect, useState } from 'react';
import PlantillaCiberalarma from '../files/CiberalarmaTemplate.xlsx';
import Actions from '../../shared/components/Actions';
import UsersLoader from '../../shared/components/UsersLoader';
import columns from '../columns';
import styled from '@emotion/styled';
import { useIdentity } from 'fractalia-provisioner/identity';
import useRowValidator from '../../shared/hooks/useRowValidator';
import useProjectCodeValidator from '../../shared/hooks/useProjectCodeValidator';
import useCiberalarma from '../hooks/useCiberalarma';
import { useApp } from '../../../app/hooks/useApp';
import UsersTable from '../../shared/components/UsersTable';
import GettingStarted from '../../shared/components/GettingStarted';
import ProvisionHistory from '../../shared/components/ProvisionHistory';
import ProjectCodeSelector from '../../shared/components/ProjectCodeSelector';

const Layout = styled(LayoutBase)`
  background-color: #fff;
  width: 100%;
`;

const { Header: HeaderBase, Content: ContentBase } = LayoutBase;

const Content = styled(ContentBase)`
  display: flex;
  justify-content: center;
`;

//========================================================================================
/*                                                                                      *
 *                                        Header                                        *
 *                                                                                      */
//========================================================================================

const Header = styled(HeaderBase)`
  background-color: #fff;
  color: #1890ff;
  height: 100px;
  display: flex;
  justify-content: space-between;
  flex-directions column;
  align-items: center;
  font-size: 1.5rem;
  font-weight: 500
  `;

//========================================================================================
/*                                                                                      *
 *                              CiberalarmaPage                                      *
 *                                                                                      */
//========================================================================================

function CiberalarmaPage() {
  // ────────────────────────────────────────────────────────────────────────────────
  // ─── constants ──────────────────────────────────────────────────────────────────
  // ────────────────────────────────────────────────────────────────────────────────

  const gettingStartedProps = {
    onStartClick: onStartClick,
    title: 'Provisionador Ciberalarma',
    text:
      'Bienvenido usuario, con la ayuda de esta herramienta usted podra provisionar usuarios en la plataforma Ciberalarma',
    templateFile: PlantillaCiberalarma,
    onShowHistory: () => {
      setStarterVisible(false);
      setHistoryVisible(true);
    },
  };

  const provisionHistoryProps = {};

  //* ────────────────────────────────────────────────────────────────────────────────────────
  //* ──── state ─────────────────────────────────────────────────────────────────────────────
  //* ────────────────────────────────────────────────────────────────────────────────────────

  const [users, setUsers] = useState({ data: [], file: null, headers: [] });
  const [tableColumns, setTableColumns] = useState([]);
  const [invalidRowsFounded, setInvalidRowsFounded] = useState([]);
  const [starterVisible, setStarterVisible] = useState(false);
  const [historyVisible, setHistoryVisible] = useState(false);
  const [restVisible, setRestVisible] = useState(false);
  const [projectCode, setProjectCode] = useState();

  //* ────────────────────────────────────────────────────────────────────────────────
  //* ──── hooks ─────────────────────────────────────────────────────────────────────
  //* ────────────────────────────────────────────────────────────────────────────────

  const app = useApp();

  const identity = useIdentity();
  const { projectCodes } = identity;
  const { user } = identity;

  const { checkInvalidRows, reduceInvalidRows } = useRowValidator(columns);

  const {
    ciberalarmaProvisioningSubmit: submit,
    ciberalarmaProvisioningSubmitRequested: submitRequested,
    ciberalarmaProvisioningSubmitSucceeded: submitSucceeded,
    ciberalarmaProvisioningSubmitFailed: submitFailed,
    ciberalarmaHistoryFetch: historyFetch,
    ciberalarmaHistoryFetchRequested: historyFetchRequested,
    ciberalarmaHistoryFetchSucceeded: historyFetchSucceeded,
    ciberalarmaHistoryFetchFailed: historyFetchFailed,
  } = useCiberalarma();

  const {
    projectCodeList,
    projectCodeGetAllSubmit,
    projectCodeGetAllSubmitRequested,
    projectCodeGetAllSubmitSucceeded,
    projectCodeGetAllSubmitFailed,
  } = useProjectCodeValidator();

  //* ────────────────────────────────────────────────────────────────────────────────────────
  //* ──── effects ───────────────────────────────────────────────────────────────────────────
  //* ────────────────────────────────────────────────────────────────────────────────────────

  useEffect(() => {
    const { onSetCurrentMenu } = app;
    onSetCurrentMenu('ciberalarma');
    setStarterVisible(true);
    setRestVisible(false);
    setHistoryVisible(false);
  }, []);

  useEffect(() => {
    if (!users.file) {
      return;
    }
    const tblCol = [];
    columns.forEach((column) => {
      if (column.isRequired || users.data.some((row) => !!row[column.key])) {
        tblCol.push({
          title: column.header,
          key: column.key,
          dataIndex: column.key,
          ellipsis: true,
          width: column.width ? column.width : null,
        });
      }
    });
    setTableColumns(tblCol);
  }, [users]);

  useEffect(() => {
    if (submitSucceeded) {
      Modal.success({
        title: 'Success',
      });
      onReset();
    }
    if (submitFailed) {
      Modal.error({
        title: 'Error',
      });
    }
  }, [submitSucceeded, submitFailed]);

  useEffect(() => {
    if (invalidRowsFounded.length > 0) {
      const reduced = reduceInvalidRows(invalidRowsFounded);
      Object.entries(reduced).forEach(([key, value]) => {
        notification.error({
          message: `Error en la ${key}`,
          description: `No se encontraron datos en la(s) column(as) ${value.reduce(
            (acc, err, index) => {
              return (
                acc + err.header + (index === value.length - 1 ? '' : ', ')
              );
            },
            ''
          )}`,
          duration: 6,
        });
      });
    }

    return () => {
      if (invalidRowsFounded > 0) setInvalidRowsFounded([]);
    };
  }, [invalidRowsFounded]);

  useEffect(() => {
    if (historyVisible) {
      const { userId } = user;
      historyFetch(userId);
    }
  }, [historyVisible]);

  //* ────────────────────────────────────────────────────────────────────────────────
  //* ──── variables ─────────────────────────────────────────────────────────────────
  //* ────────────────────────────────────────────────────────────────────────────────
  const { logout } = identity;

  //* ────────────────────────────────────────────────────────────────────────────────
  //* ──── functions ─────────────────────────────────────────────────────────────────
  //* ────────────────────────────────────────────────────────────────────────────────

  function onSubmit() {
    const invalidRows = checkInvalidRows(users.data);
    if (invalidRows && invalidRows.length > 0) {
      const reduced = reduceInvalidRows(invalidRows);
      Object.entries(reduced).forEach(([key, value]) => {
        notification.error({
          message: `Error en la ${key}`,
          description: `No se encontraron datos en la(s) column(as) ${value.reduce(
            (acc, err, index) => {
              return (
                acc + err.header + (index === value.length - 1 ? '' : ', ')
              );
            },
            ''
          )}`,
          duration: 6,
        });
      });
      return;
    }
    let actionInvalid = false;
    users.data.forEach((row, index) => {
      if (Object.prototype.hasOwnProperty.call(row, 'action')) {
        const validActions = ['new', 'resume', 'pause', 'del'];
        const rowAction = row.action.replace(/\s+/g, '').toLowerCase();
        if (!validActions.includes(rowAction)) {
          notification.error({
            message: `Action invalido en la fila ${index + 1}`,
            description: 'NEW - RESUME - PAUSE - DEL',
            duration: 6,
          });
          actionInvalid = true;
        }
      }
    });

    if (actionInvalid) {
      return;
    }

    if (!projectCode) {
      notification.error({
        message: 'Debe seleccionar la plataforma a provisionar',
        duration: 4,
      });
      return;
    }
    const { projects, userId } = user;
    const projectCodeId = projects.find((p) => p.name === projectCode).code;
    const data = users.data.map((u) => {
      return { ...u, userId, projectCode: projectCodeId };
    });
    submit(data, users.file);
  }

  function onReset() {
    setUsers({ data: [], file: null, headers: [] });
    setTableColumns([]);
  }

  function onStartClick() {
    setStarterVisible(false);
    setRestVisible(true);
  }

  function getProjectCodes() {
    return projectCodes.map((pc) => {
      return { label: pc, value: pc };
    });
  }

  function onShowInfo() {
    setStarterVisible(true);
    setRestVisible(false);
  }

  function getProjectsOptions() {
    const { projects } = user;
    const list = projects.map((p) => {
      return { value: p.name, label: p.description };
    });

    return list.filter((e) => e.value.startsWith('CBA'));
  }

  //* ────────────────────────────────────────────────────────────────────────────────────────
  //* ──── component ─────────────────────────────────────────────────────────────────────────
  //* ────────────────────────────────────────────────────────────────────────────────────────

  return (
    <Layout>
      {starterVisible && <GettingStarted {...gettingStartedProps} />}
      {restVisible && (
        <Spin
          spinning={
            submitRequested ||
            projectCodeGetAllSubmitRequested ||
            projectCodeGetAllSubmitFailed
          }
        >
          <Content>
            {!users.file && (
              <UsersLoader
                onLoad={(e) => {
                  setUsers({
                    data: e.data,
                    file: e.file,
                    headers: e.headers,
                  });
                }}
                columns={columns}
              />
            )}
            {users.file && (
              <div>
                <UsersTable
                  columns={tableColumns}
                  dataSource={users.data}
                  size="small"
                  tableLayout="fixed"
                  scroll={{ x: 1300 }}
                />
                <div css={{ display: 'flex', justifyContent: 'space-between' }}>
                  <ProjectCodeSelector
                    options={getProjectsOptions()}
                    onChange={(code) => setProjectCode(code)}
                    value={projectCode}
                  />
                  <Actions
                    onSubmit={onSubmit}
                    onReset={onReset}
                    onShowInfo={onShowInfo}
                  />
                </div>
              </div>
            )}
          </Content>
        </Spin>
      )}
    </Layout>
  );
}

export default CiberalarmaPage;
